import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';

const Settings = ({ players, onUpdatePlayers, settings, onUpdateSettings }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChangeDelay = (playerId, delay) => {
        const updatedPlayers = players.map(player =>
            player.id === playerId ? { ...player, delay } : player
        );
        onUpdatePlayers(updatedPlayers);
    };

    const handleChangeDelayType = (event) => {
        const delayType = event.target.value;
        const newSettings = { ...settings, delayType: delayType};
        const updatedPlayers = [...players];
        // If not manual, set all delays to zero
        if (delayType !== "manual") {
            updatedPlayers.map(player => player.delay = 0);
        }
        onUpdatePlayers(updatedPlayers);
        onUpdateSettings(newSettings);
    };

    return (
        <>
            <button
                type="button"
                className="sg-iconbtn"
                onClick={handleOpen}
                aria-label="Settings"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" fill="none" />
                    <path
                        d="M12 2.5l1.4 2.4 2.7-.5.6 2.7 2.4 1.4-1.2 2.5 1.2 2.5-2.4 1.4-.6 2.7-2.7-.5L12 21.5l-1.4-2.4-2.7.5-.6-2.7-2.4-1.4 1.2-2.5-1.2-2.5 2.4-1.4.6-2.7 2.7.5L12 2.5z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinejoin="round"
                        fill="none"
                    />
                </svg>
            </button>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <span className="sg-kicker">Game settings</span>
                    <h2 style={{ fontSize: '1.6rem', margin: '4px 0 0' }}>Delay handicaps</h2>
                </DialogTitle>
                <DialogContent>
                    <Box paddingBottom={2} textAlign="left">
                        <div className="sg-faint" style={{ fontWeight: 600, marginBottom: 12 }}>
                            Give some players a head start by delaying when faster players can play.
                        </div>
                        <Box paddingBottom={1} sx={{ fontWeight: 700, color: 'var(--ink-soft)' }}>Delay type</Box>
                        <Select
                            value={settings.delayType || 'none'}
                            onChange={handleChangeDelayType}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                        >
                            <MenuItem value="none">None</MenuItem>
                            <MenuItem value="manual">Manual</MenuItem>
                            <MenuItem value="automatic">Automatic</MenuItem>
                        </Select>
                    </Box>
                    {settings.delayType === "manual" &&
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Player Name</TableCell>
                                <TableCell>Time Delay</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {players.map(player => (
                                <TableRow key={player.id}>
                                    <TableCell>{player.name}</TableCell>
                                    <TableCell>
                                        <Select
                                            value={player.delay || 0}
                                            onChange={(e) => handleChangeDelay(player.id, e.target.value)}
                                            fullWidth
                                        >
                                            <MenuItem value={0}>0 seconds</MenuItem>
                                            <MenuItem value={5}>5 seconds</MenuItem>
                                            <MenuItem value={10}>10 seconds</MenuItem>
                                        </Select>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Settings;
